import React, { useState } from "react";
import { StyleSheet, View, Platform } from "react-native";
import { capitalize } from "lodash";

import { buttonStyle } from "../common/ActionsMenuButton/utils";
import { getContactMailUrl, openURL } from "../../../helpers/utils";
import AppTheme from "../AppTheme";

import ActionButton from "../common/ActionsMenuButton/ActionButton";
import InviteIcon from "../common/ActionsMenuButton/icons/InviteIcon";
import NewElementIcon from "../common/ActionsMenuButton/icons/NewElementIcon";
import RoutinesIcon from "../common/icons/RoutinesIcon";
import ReflectionSwitchViewIcon from "../common/ActionsMenuButton/icons/ReflectionSwitchViewIcon";
import ReportsIcon from "../common/ActionsMenuButton/icons/ReportsIcon";
import IntegrationIcons from "../common/icons/integrations/index";
import OperationIcon from "../common/ActionsMenuButton/icons/OperationIcon";
import ViewModes from "./header/viewModes";

export default function ReflectionFabButton(props) {
  const {
    isAdmin,
    aboutThisScreen,
    viewMode,
    changeViewMode,
    showEditSetsView,
    timeUnit,
    createNewRoutine,
    createNewReport,
    downloadCsv,
    viewAutoTrackMode,
    syncCalendar,
    style,
    mariOptions = {},
  } = props;
  const [actionButton, setActionButton] = useState(null);

  const actions = [
    <ActionButton.Item
      key={1}
      underline={!aboutThisScreen}
      hideShadow
      buttonColor="#FFF"
      title="Help"
      onPress={() => {
        openURL(getContactMailUrl());
      }}
    >
      <InviteIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,
  ];

  if (aboutThisScreen) {
    actions.push(
      <ActionButton.Item
        key={11}
        underline
        hideShadow
        buttonColor="#FFF"
        title="About this screen"
        onPress={aboutThisScreen}
      >
        <InviteIcon style={styles.actionButtonIcon} />
      </ActionButton.Item>,
    );
  }

  if (viewMode !== ViewModes.insights) {
    actions.push(
      <ActionButton.Item
        key={51}
        hideShadow
        buttonColor="#FFF"
        title="Switch to Insights View"
        onPress={() => changeViewMode(ViewModes.insights)}
      >
        <ReflectionSwitchViewIcon
          viewMode={ViewModes.insights}
          style={{ vidth: 20, height: 20 }}
        />
      </ActionButton.Item>,
    );
  }

  if (viewMode !== ViewModes.chartView) {
    actions.push(
      <ActionButton.Item
        key={52}
        hideShadow
        buttonColor="#FFF"
        title="Switch to Chart View"
        onPress={() => changeViewMode(ViewModes.chartView)}
      >
        <ReflectionSwitchViewIcon
          viewMode={ViewModes.chartView}
          style={styles.actionButtonIcon}
        />
      </ActionButton.Item>,
    );
  }

  if (viewMode !== ViewModes.tableView) {
    actions.push(
      <ActionButton.Item
        key={53}
        hideShadow
        buttonColor="#FFF"
        title="Switch to Table View"
        onPress={() => changeViewMode(ViewModes.tableView)}
      >
        <ReflectionSwitchViewIcon
          viewMode={ViewModes.tableView}
          style={styles.actionButtonIcon}
        />
      </ActionButton.Item>,
    );
  }

  if (showEditSetsView) {
    actions.push(
      <ActionButton.Item
        key={3}
        hideShadow
        buttonColor="#FFF"
        title="Customize Elements"
        onPress={showEditSetsView}
      >
        <NewElementIcon />
      </ActionButton.Item>,
    );
  }

  if (createNewRoutine) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={4}
        buttonColor="#FFF"
        title={`Create ${capitalize(timeUnit)} Routine`}
        onPress={createNewRoutine}
      >
        <RoutinesIcon onPress={createNewRoutine} />
      </ActionButton.Item>,
    );
  }

  if (createNewReport) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={5}
        buttonColor="#FFF"
        title="Create Report"
        onPress={createNewReport}
      >
        <ReportsIcon />
      </ActionButton.Item>,
    );
  }

  if (downloadCsv) {
    actions.push(
      <ActionButton.Item
        underline
        hideShadow
        key={6}
        buttonColor="#FFF"
        title="Download CSV"
        onPress={downloadCsv}
      >
        <IntegrationIcons.DownloadIcon />
      </ActionButton.Item>,
    );
  }

  if (viewAutoTrackMode) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={7}
        buttonColor="#FFF"
        title="View Autotrack Mode"
        onPress={viewAutoTrackMode}
      >
        <OperationIcon />
      </ActionButton.Item>,
    );
  }

  if (syncCalendar) {
    actions.push(
      <ActionButton.Item
        hideShadow
        key={8}
        buttonColor="#FFF"
        title="Sync Calendar"
        onPress={syncCalendar}
      >
        <ReportsIcon />
      </ActionButton.Item>,
    );
  }

  return (
    <View
      style={[buttonStyle, style]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"ReflectionFabButton"}
        buttonTextStyle={styles.mainButton}
      >
        {actions}
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  mainButton: {
    fontSize: 44,
    height: 58,
    marginTop: -5,
    fontWeight: "200",
    fontFamily: Platform.select({
      default: "Nunito",
      android: "Nunito-Regular",
    }),
  },
  actionButtonIcon: {
    marginTop: 5,
    width: 44,
    height: 44,
  },
});
